import { getListOfGatewayName } from "../types/gateway_name_list_types";

const initState = {
  data: [],
  count: 0,
  loading: false,
  error: null,
  cellLoading: null,
};

export default function gatewayNameListReducer(state = initState, action = {}) {
  switch (action.type) {
    case getListOfGatewayName.GET_LIST_OF_GATEWAY_NAME_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfGatewayName.GET_LIST_OF_GATEWAY_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        count: action.payload.count,
        error: null,
      };
    case getListOfGatewayName.GET_LIST_OF_GATEWAY_NAME_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
